import React from 'react';
import { AgentsContext, AuthContext } from 'contexts';
import { Contact, Icon, ListItem, UserSelect } from 'components';
import { MessageSearchState, SelectedRep } from './hooks';

interface MessageUserSearchProps {
  searchState: MessageSearchState;
  userInfo?: SelectedRep;
  setSearchState: React.Dispatch<React.SetStateAction<MessageSearchState>>;
}

const MessageUserSearch: React.FC<MessageUserSearchProps> = ({
  searchState,
  userInfo,
  setSearchState,
}) => {
  const { orgUsersMap } = React.useContext(AgentsContext);
  const { auth } = React.useContext(AuthContext);

  return userInfo || searchState.user ? (
    <ListItem>
      <Contact
        contact={userInfo || searchState.user}
        showBranchName
        avatarSize={32}
        {...(searchState.user?.id === 'ALL' ? { disableClick: true } : {})}
      />
      {!userInfo && (
        <button
          onClick={() => setSearchState(({ user: _user, ...prev }) => prev)}
        >
          <Icon type="x" />
        </button>
      )}
    </ListItem>
  ) : (
    <UserSelect
      showSearch
      selectAllAvailable={auth.roles[auth.role] >= auth.roles.GLOBAL_ADMIN}
      value={[]}
      label="User Inbox"
      onChange={([uid]) => {
        setSearchState(prev => ({
          ...prev,
          user:
            uid === 'ALL'
              ? { id: 'ALL', firstName: 'SEARCH ENTIRE BROKERAGE' }
              : orgUsersMap![uid],
        }));
      }}
    />
  );
};

export default MessageUserSearch;
